import React, { useEffect, useState } from 'react';
import { CustomAutocompleteFreeSolo } from 'components/shared/DropDown/CustomAutocomplete';
import { UserLanguageSelector } from './UserLanguageSelector';

import { PHONENUMBER_REGEX } from 'utils/Regex';
import { useTranslation } from 'react-i18next';
import { LANGUAGES } from 'utils/Constants';

export const AssignClient = (props) => {
  const { t } = useTranslation();
  const [name, setName] = useState(null);
  const [mail, setMail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  const [selectedLanguage, setSelectedLanguage] = useState(null);

  useEffect(() => {
    setName(props.data.name);
    setMail(props.data.mail);
    setPhoneNumber(props.data.phoneNumber);

    // Initialize language selection from props
    const lang = LANGUAGES.find(
      (l) => l.isoCode === props.data.isoLanguageCode
    );
    setSelectedLanguage(lang || null);
  }, [props, props.data]);

  const handleLanguageChange = (option) => {
    setSelectedLanguage(option);
    props.updateClientsList('isoLanguageCode', option?.isoCode || '');
  };

  return (
    <div className="row row-mb">
      <div className="col-12 col-md-4">
        <div className="label-title">{t('Prénom / Nom du client')}</div>
        <CustomAutocompleteFreeSolo
          list={props.list}
          value={name}
          onInputChange={(value) => {
            props.updateClientsList('name', value);
          }}
          setValue={(value) => {
            if (
              value &&
              value.id &&
              props.list.length > 0 &&
              props.list.some((x) => x.id === value.id)
            ) {
              const client = props.list.find((x) => x.id === value.id);
              props.updateClientsList('name', client.name);
              props.updateClientsList('mail', client.mail);
              props.updateClientsList('phoneNumber', client.phoneNumber);
              props.updateClientsList(
                'isoLanguageCode',
                client.isoLanguageCode
              );
              props.updateClientsList('isNew', false);
            } else {
              props.updateClientsList('mail', '');
              props.updateClientsList('phoneNumber', '');
              props.updateClientsList('isoLanguageCode', '');
              props.updateClientsList('isNew', true);
            }
          }}
          getOptionLabel={(option) =>
            option.hasOwnProperty('name') ? option.name : option
          }
        />
      </div>
      <div className="col-12 col-md-4">
        <div className="label-title">{t('Mail client')}</div>
        <input
          onChange={(e) => props.updateClientsList('mail', e.target.value)}
          value={mail}
          type="text"
          className="form-control form-ct"
        />
      </div>
      <div className="col-12 col-md-4">
        <div className="label-title">{t('Téléphone')}</div>
        <input
          onChange={(e) => {
            if (
              e.target.value === '' ||
              PHONENUMBER_REGEX.test(e.target.value)
            ) {
              props.updateClientsList('phoneNumber', e.target.value);
            }
          }}
          value={phoneNumber}
          type="text"
          className="form-control form-ct"
        />
      </div>
      <div className="col-12 col-md-4">
        <UserLanguageSelector
          selectedLanguage={selectedLanguage}
          onLanguageChange={handleLanguageChange}
        />
      </div>
      {(props.isDeleteable && props.id) || props.new === false ? (
        <div
          className="col-12 col-md-1"
          onClick={() => props.deleteClient(props.id)}
        >
          <div className="bt-minus-circle" style={{ marginTop: 25 }} />
        </div>
      ) : (
        <div className="col-12 col-md-1" onClick={props.addClient}>
          <div className="bt-plus-circle" style={{ marginTop: 25 }} />
        </div>
      )}
    </div>
  );
};
